import { MessageCircle, Map, Vote, Stamp } from "lucide-react";

const modules = [
  { icon: MessageCircle, title: "Chat", text: "Comenta el momento que ves en TV." },
  { icon: Vote, title: "Vota", text: "Elige el siguiente reto del dúo." },
  { icon: Map, title: "Mapa", text: "Sigue el punto exacto de la ruta." },
  { icon: Stamp, title: "Pasaporte", text: "Suma un sello con el episodio." },
];

export const LiveSecondScreen = () => (
  <div data-testid="live-second-screen-modules" className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
    {modules.map(({ icon: Icon, title, text }) => (
      <article key={title} data-testid={`live-module-${title.toLowerCase()}`} className="border-l-2 border-mint bg-ink p-5 text-cream">
        <Icon className="h-5 w-5 text-mint" aria-hidden="true" />
        <h3 className="mt-4 font-display text-lg font-bold">{title}</h3>
        <p className="mt-1 text-sm leading-relaxed text-cream/60">{text}</p>
      </article>
    ))}
  </div>
);